'use client';

import Image from 'next/image';

export default function Hero() {
    return (
        <div className="relative mt-[54px] mb-5 min-h-72 lg:mt-[77px] xl:mb-0 xl:min-h-[calc(100svh-77px)]">
            <Image
                src={'/images/about/carousel/car-1.jpg'}
                alt="Hero Image"
                className="object-cover"
                fill
            />
        </div>
    );
}
